// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2dvgm","title":"AfterBackImages_title__3_WmM","images":"AfterBackImages_images__6dH2j"};